export var DocumentType;
(function (DocumentType) {
    DocumentType["CPF"] = "CPF";
    DocumentType["CNPJ"] = "CNPJ";
})(DocumentType || (DocumentType = {}));
export var ChannelEnum;
(function (ChannelEnum) {
    ChannelEnum["phone"] = "phone";
    ChannelEnum["email"] = "email";
    ChannelEnum["whatsapp"] = "whatsapp";
})(ChannelEnum || (ChannelEnum = {}));
export var DeviceValidationErrors;
(function (DeviceValidationErrors) {
    DeviceValidationErrors["DEVICE_NOT_FOUND"] = "DEVICE_NOT_FOUND";
    DeviceValidationErrors["DEVICE_ID_INVALID"] = "DEVICE_ID_INVALID";
    DeviceValidationErrors["TOKEN_INVALID"] = "TOKEN_INVALID";
    DeviceValidationErrors["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
})(DeviceValidationErrors || (DeviceValidationErrors = {}));
export var TemplateEnum;
(function (TemplateEnum) {
    TemplateEnum["VALIDATION_TOKEN_TEMPLATE"] = "VALIDATION_TOKEN_TEMPLATE";
    TemplateEnum["RESET_PASSWORD"] = "RESET_PASSWORD";
    TemplateEnum["RESET_PIN"] = "RESET_PIN";
})(TemplateEnum || (TemplateEnum = {}));
export var DeviceTypeEnum;
(function (DeviceTypeEnum) {
    DeviceTypeEnum["phone"] = "phone";
    DeviceTypeEnum["tablet"] = "tablet";
})(DeviceTypeEnum || (DeviceTypeEnum = {}));
export var LoginErrorsType;
(function (LoginErrorsType) {
    LoginErrorsType["INVALID_CREDENTIALS"] = "CREDENTIAL_INVALID";
    LoginErrorsType["MISSING_CREDENTIALS"] = "MISSING_CREDENTIALS";
    LoginErrorsType["INVALID_CREDENTIALS_FOR_USER_PARTY_RELATIONSHIP"] = "INVALID_CREDENTIALS_FOR_USER_PARTY_RELATIONSHIP";
    LoginErrorsType["FEATURE_NOT_ENABLED"] = "FEATURE_NOT_ENABLED";
    LoginErrorsType["AUTH_TOKEN_EXPIRED"] = "AUTH_TOKEN_EXPIRED";
    LoginErrorsType["GENERIC"] = "BUSINESS_ERROR";
    LoginErrorsType["CREDENTIAL_ROLE_INVALID"] = "CREDENTIAL_ROLE_INVALID";
    LoginErrorsType["MAINTENANCE"] = "LOGIN_MAINTENANCE";
})(LoginErrorsType || (LoginErrorsType = {}));
